import React, { useEffect } from "react";
import "./DosaChutneyGallery.scss"
import border from "../../assets/images/border.png"
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";
const DosaChutneyGallery = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "gallery")
    const Components = page?.Components || []

    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyGallery-Hero-header":
                return <div className="DosaChutneyGallery-Hero-header">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyGallery-Hero-subheader":
                return <div className="DosaChutneyGallery-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="DosaChutneyGallery-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getContainerContentComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyGallery-Container-header-subtext":
                return <div className="DosaChutneyGallery-Container-header-subtext">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyGallery-Container-header-text":
                return <div className="DosaChutneyGallery-Container-header-text">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyGallery-Container-border":
                return <img alt="" src={border}
                    className="DosaChutneyGallery-Container-header-border" />
            case "DosaChutneyGallery-Container-header-content":
                return <div className="DosaChutneyGallery-Container-header-content">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getGallery = (data) => {
        return (
            <div className="DosaChutneyGallery-Container-grid">
                {data?.map((gallery, key) => {
                    return (
                        <img alt="" key={key} src={gallery?.src}
                            className="DosaChutneyGallery-Container-grid-img" />
                    )
                })}
            </div>
        )
    }
    const getContainerContent = (components) => {
        return (
            <div className="DosaChutneyGallery-Container-header">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getContainerContentComponent(component)
                    )
                })}
            </div>
        )
    }
    const getGalleryContentComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyGallery-Container-header":
                return getContainerContent(component?.Components)
            case "DosaChutneyGallery-Container-gallery":
                return getGallery(component?.Data)
            default:
                return <div />
        }

    }
    const getGalleryContent = (components) => {
        return (
            <div className="DosaChutneyGallery-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getGalleryContentComponent(component)
                    )
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyGallery-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "DosaChutneyGallery-Container":
                return getGalleryContent(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="DosaChutneyGallery">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default DosaChutneyGallery
